import React from 'react';
import { IconWrapper } from '../runtime';
export default IconWrapper('pill', true, function (props) {
  return /*#__PURE__*/React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.61497 22.5852C4.4434 21.4136 4.4434 19.5141 5.61497 18.3425L18.3429 5.61463C19.5145 4.44305 21.414 4.44305 22.5855 5.61462L42.3845 25.4136C43.5561 26.5852 43.5561 28.4847 42.3845 29.6563L29.6566 42.3842C28.485 43.5557 26.5855 43.5557 25.414 42.3842L5.61497 22.5852Z",
    fill: props.colors[1],
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinejoin: props.strokeLinejoin
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "14.8079",
    cy: "20.4648",
    r: "2",
    transform: "rotate(-45 14.8079 20.4648)",
    fill: props.colors[2]
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "23.2928",
    cy: "28.9492",
    r: "2",
    transform: "rotate(-45 23.2928 28.9492)",
    fill: props.colors[2]
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "19.0501",
    cy: "24.707",
    r: "2",
    transform: "rotate(-45 19.0501 24.707)",
    fill: props.colors[2]
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "27.5364",
    cy: "33.1934",
    r: "2",
    transform: "rotate(-45 27.5364 33.1934)",
    fill: props.colors[2]
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "20.4642",
    cy: "14.8066",
    r: "2",
    transform: "rotate(-45 20.4642 14.8066)",
    fill: props.colors[2]
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "28.95",
    cy: "23.293",
    r: "2",
    transform: "rotate(-45 28.95 23.293)",
    fill: props.colors[2]
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "24.7073",
    cy: "19.0508",
    r: "2",
    transform: "rotate(-45 24.7073 19.0508)",
    fill: props.colors[2]
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "33.1927",
    cy: "27.5352",
    r: "2",
    transform: "rotate(-45 33.1927 27.5352)",
    fill: props.colors[2]
  }));
});